<template>
    <div>
        <!-- style="border: 1px solid #1286ff;" -->
        <div >
            <div :style="{width: '100%',height: heightA-4+'px',background: 'black'}">

                <div style="width: 100%;height: 10%;color: #1286ff;padding-top: 10px;font-size: 11px;">
                <div style="width: 50%;float: left;margin-left: 10px;">
                    <div>Name：{{ brName }}</div>
                    <div>Modality：{{ brModality }}</div>
                    <div>PatientID：{{ brPatientID }}</div>
                </div>
                <div style="width: 40%;float: left;margin-right: 10px;">
                    <div style="float: right;">{{ brStudyTime }}</div>
                </div>
            </div>
            <canvas style="" ref="canvas" :width="width" :height="height" @touchmove="handleTouchMove" @touchend="handleTouchEnd"></canvas>
            </div>
        </div>

        <div style="width: 100%;background: #262830; position: absolute;bottom: 0;">
            <div style="height: 50px;border-bottom: 1px solid #000;">
                <div @click="changesx()" style="margin-left: 10px;width: 20%;height: 50px;float: left;display: flex;align-items: center;justify-content: center;color: #1286ff;border-right: 1px solid #000;">
                    序列
                    <i v-if="oksxchange" style="font-size: 20px;margin-left: 3px;" class="el-icon-arrow-up"></i>
                    <i v-if="!oksxchange" style="font-size: 20px;margin-left: 3px;" class="el-icon-arrow-down"></i>
                </div>
                <div v-if="pictures.length > 1" @click="changeCanvas()" style="width: 10%;height: 50px;float: left;display: flex;align-items: center;justify-content: center;color: #1286ff;">
                    <i v-if="!okPlay" style="font-size: 30px" class="el-icon-video-play"></i>
                    <i v-if="okPlay" style="font-size: 30px" class="el-icon-video-pause"></i>
                </div>

                <div v-if="pictures.length > 1" style="width: 65%;height: 50px;float: left;" >
                    <div @click="changeCanvaslll(2)" style="width: 15%;height: 50px;float: left;display: flex;align-items: center;justify-content: center;color: #1286ff;">
                        <i style="font-size: 20px" class="el-icon-arrow-left"></i>
                    </div>
                    <div style="margin-left: 10px;width: 60%;float: left;">
                        <van-slider @input="changeCanvas333" style="width: 100%;height: 15px;color: #1286ff;margin-top: 17px;" v-model="slidernub" :max="slidersize" :show-tooltip="false"></van-slider>
                    </div>
                    <div @click="changeCanvaslll(1)" style="margin-left: 10px;width: 15%;height: 50px;float: left;display: flex;align-items: center;justify-content: center;color: #1286ff;">
                        <i style="font-size: 20px" class="el-icon-arrow-right"></i>
                    </div>
                </div>
            </div>

            <el-collapse-transition>
                <div v-show="oksxchange" style="height: 130px;margin-top: 10px;" class="transition-box">
                    <el-carousel trigger="click" @change="changeCanvas222" type="card" height="100px" width="100px" :loop="false" :autoplay="false">
                        <el-carousel-item v-for="(item,index) in masterPictures" :key="item" style="background: black;display: flex;align-items: center;justify-content: center;">
                            <div class="image-container">
                                <img style="width: 80px;height: 90px;" :src="item" />
                                <div class="text-overlay">[{{masterPicturesindex[index]}}]</div>
                            </div>
                        </el-carousel-item>
                    </el-carousel>
                </div>
            </el-collapse-transition>

            <!-- <el-collapse-transition>
                <div v-show="oksxchange" style="height: 130px;margin-top: 10px;" class="transition-box">
                    <van-swipe class="my-swipe" @change="changeCanvas222" type="card" height="100px" width="100px" :loop="false" >
                        <van-swipe-item v-for="item in masterPictures" :key="item" style="background: black;display: flex;align-items: center;justify-content: center;">
                            <img style="width: 80px;height: 90px;" :src="item" />
                        </van-swipe-item>
                    </van-swipe>
                </div>
            </el-collapse-transition> -->
            
            <div v-if="dddindex==5" style="height: 40px;width: 100%; border-top: 1px solid #000;">
                <div @click="spflipCanvas" style="height: 35px;width: 20%;font-size: 13px;color: white;float: left;display: flex;align-items: center;justify-content: center;border: 1px solid white;border-radius: 40px;">
                    水平翻转
                </div>
                <div @click="sxflipCanvas" style="height: 35px;width: 20%;font-size: 13px;color: white;float: left;display: flex;align-items: center;justify-content: center;border: 1px solid white;border-radius: 40px;">
                    垂直翻转
                </div>
                <div @click="czflipCanvas" style="height: 35px;width: 20%;font-size: 13px;color: white;float: left;display: flex;align-items: center;justify-content: center;border: 1px solid white;border-radius: 40px;">
                    重置翻转
                </div>
            </div>

            <div style="height: 60px;border-top: 1px solid #000;position: relative;clear: both;">
                <div @click="clickdbd(0)" style="height: 60px;width: 20%;color: #cfd9e4;float: left;" :class="[dddindex==0?'selectcoucss':'']">
                    <i style="margin-top: 3px;font-size: 25px;display: flex;align-items: center;justify-content: center;" class="el-icon-reading"></i>
                    <div style="width: 100%;height: 30px;display: flex;align-items: center;justify-content: center;">翻页</div>
                </div>
                <!-- <div @click="clickdbd(1)" style="height: 60px;width: 16%;color: #cfd9e4;float: left;" :class="[dddindex==1?'selectcoucss':'']">
                    <i style="margin-top: 3px;font-size: 25px;display: flex;align-items: center;justify-content: center;" class="el-icon-s-tools"></i>
                    <div style="width: 100%;height: 30px;display: flex;align-items: center;justify-content: center;">调窗</div>
                </div> -->
                <div @click="clickdbd(2)" style="height: 60px;width: 20%;color: #cfd9e4;float: left;" :class="[dddindex==2?'selectcoucss':'']">
                    <i style="margin-top: 3px;font-size: 25px;display: flex;align-items: center;justify-content: center;" class="el-icon-zoom-out"></i>
                    <div style="width: 100%;height: 30px;display: flex;align-items: center;justify-content: center;">缩放</div>
                </div>
                <!-- <div @click="clickdbd(3)" style="height: 60px;width: 16%;color: #cfd9e4;float: left;" :class="[dddindex==3?'selectcoucss':'']">
                    <i style="margin-top: 3px;font-size: 25px;display: flex;align-items: center;justify-content: center;" class="el-icon-zoom-in"></i>
                    <div style="width: 100%;height: 30px;display: flex;align-items: center;justify-content: center;">放大镜</div>
                </div> -->
                <div @click="clickdbd(4)" style="height: 60px;width: 20%;color: #cfd9e4;float: left;" :class="[dddindex==4?'selectcoucss':'']">
                    <i style="margin-top: 3px;font-size: 25px;display: flex;align-items: center;justify-content: center;" class="el-icon-rank"></i>
                    <div style="width: 100%;height: 30px;display: flex;align-items: center;justify-content: center;">移动</div>
                </div>
                <div @click="clickdbd(5)" style="height: 60px;width: 20%;color: #cfd9e4;float: left;" :class="[dddindex==5?'selectcoucss':'']">
                    <i style="margin-top: 3px;font-size: 25px;display: flex;align-items: center;justify-content: center;" class="el-icon-refresh-left"></i>
                    <div style="width: 100%;height: 30px;display: flex;align-items: center;justify-content: center;">翻转</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "canvass",
    data() {
        return {
            fullscreenLoading: true,
            yxpurl:"https://jh.shjhyy.com/weChat/",
            // yxpurl:"http://localhost:8861/weChat/",
            intervalId: null,
            okPlay:false,
            oksxchange:true,
            slidersize:0,
            dddindex:0,
            imageCache:[],
            slidernub:0,
            width: 0,
            height: 0,
            heightA: 0,
            masterPictures:[],
            masterPicturesindex:[],
            pictures:[],
            imagelist:[],
            lwpatient:[],
            brName:'',
            brModality:'',
            brPatientID:'',
            brStudyTime:'',
            imageidd:[],
            pathh:'',

            startX: 0,
            startY: 0,
            startX1: 0,
            startY1: 0,
            sfWidth:0,
            sfHeight:0,
            sfcurrentY:0,

        }
    },
    mounted() {
        this.updateWindowDimensions()
        window.addEventListener('resize', this.updateWindowDimensions);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateWindowDimensions);
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.slidernub=0
        }
    },
    created() {
        this.getData();
        this.slidersize = (this.pictures.length < 1 ? 0:this.pictures.length-1)
    },
    methods: {
        changesx(){
            this.oksxchange = !this.oksxchange
        },
        changeCanvas(){
            if(this.dddindex==0){
                if(!this.okPlay){
                    this.okPlay=true;
                    this.intervalId = setInterval(this.refreshData, 500);
                }else{
                    this.okPlay=false;
                    clearInterval(this.intervalId);
                }
            }else{
                this.okPlay=false;
                clearInterval(this.intervalId);
            }
        },
        changeCanvas222(iddd){
            this.setPictures(iddd);
        },
        changeCanvas333(iddd){
            this.slidernub = iddd;
            let inx = this.slidernub;
            this.loadImage(this.pictures[inx]);

            // const loading = this.$loading({
            //         lock: true,
            //         text: 'Loading',
            //         spinner: 'el-icon-loading',
            //         background: 'rgba(0, 0, 0, 0.7)'
            //     });
            //     let timelong = 400
            //     setTimeout(() => {
            //         loading.close();
            //     }, timelong);

            let canindex = inx+10 > this.pictures.length ? this.pictures.length : inx+10
            for(var j=inx+1;j<canindex;j++){
                this.setImage(this.pictures[j]);
            }
        },
        changeCanvaslll(idd){
            if(this.okPlay){
                this.changeCanvas()
            }
            if(idd==1){
                this.slidernub = (this.slidernub >= this.pictures.length-1 ? 0: this.slidernub+1)
            }else{
                this.slidernub = (this.slidernub-1 <= 0 ? 0: this.slidernub-1)
            }
            let inx = this.slidernub;
            this.loadImage(this.pictures[inx]);
            
            let canindex = inx+10 > this.pictures.length ? this.pictures.length : inx+10
            for(var j=inx+1;j<canindex;j++){
                this.setImage(this.pictures[j]);
            }
        },
        refreshData(){
            if(this.pictures.length > 0){
                this.slidernub = (this.slidernub >= this.pictures.length-1 ? 0: this.slidernub+1)
                let inx = this.slidernub;
                // this.drawImageOnCanvas(this.pictures[inx]);
                this.loadImage(this.pictures[inx]);
                
                let canindex = inx+10 > this.pictures.length ? this.pictures.length : inx+10
                for(var j=inx+1;j<canindex;j++){
                    this.setImage(this.pictures[j]);
                }
            }
        },
        getData(){
            
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let ss = window.location.search.split("?studyuid=")[1]
            let dddss = ss.split("&yxh=")
            this.$axios.get(this.yxpurl+"getPacsImageList", {
                params: {
                    studyuid: dddss[0],
                    yxh: dddss[1]
                }
            }).then(res => {
                if(res.data.code === 200){
                    
                    let timelong = 400
                    setTimeout(() => {
                        loading.close();
                    }, timelong);

                    this.pathh = res.data.pathh
                    // this.imagelist = JSON.parse(res.data.imagelist)
                    this.imagelist = res.data.imagelist
                    // this.lwpatient = res.data.lwpatient
                    if(this.imagelist && this.imagelist.length > 0){
                        this.brName = this.imagelist[0].brxm
                        this.brModality = this.imagelist[0].exampartdetail
                        this.brPatientID = this.imagelist[0].studyid
                        this.brStudyTime = this.imagelist[0].reportdate
                    // for(var i=0;i<this.imagelist.length;i++){
                        const ser = this.imagelist[0];
                        this.masterPictures.push(this.yxpurl+"downloadpacs?path="+ btoa(ser['imagepath']));
                        this.masterPicturesindex.push(this.imagelist.length)
                    // }
                        this.setPictures(0);
                    }
                }
            })
        },
        async setPictures111(idd){
            let iddd = 0;
            for(var i=0;i<this.imagelist.length;i++){
                const ser = this.imagelist[i];
                const urlss = this.yxpurl+"downloadpacs?path="+btoa(ser['imagepath']);
                this.setImage(urlss);
            }
        },
        setPictures(idd){
            clearInterval(this.intervalId);
            this.okPlay=false;
            this.slidernub = 0;
            let iddd = 0;
            this.pictures = []
            if(!this.imageidd[idd]){
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });

                const indlen = this.imagelist.length
                let timelong = 1000
                if(50 < indlen && indlen < 100){
                    timelong = 1500
                }else if(100 < indlen && indlen < 200){
                    timelong = 2000
                }else if(200 < indlen && indlen < 300){
                    timelong = 3000
                }else if(300 < indlen && indlen < 500){
                    timelong = 4000
                }else if(500 < indlen){
                    timelong = 70000
                }
                setTimeout(() => {
                    loading.close();
                }, timelong);
                this.imageidd.push(idd)
            }
            for(var i=0;i<this.imagelist.length;i++){
                const ser = this.imagelist[i];
                const urlss = this.yxpurl+"downloadpacs?path="+btoa(ser['imagepath']);
                this.pictures.push(urlss);
            }
            this.slidersize = (this.pictures.length < 1 ? 0:this.pictures.length-1);
            if(this.pictures.length > 0){
                let inx = this.slidernub;
                this.loadImage(this.pictures[inx]);
            }

            this.setPictures111(idd+1)
            // this.loadImage('/image.png');
        },
        changeCanvasFS(){
            
            const canvas = this.$refs.canvas;
            const ctx = canvas.getContext('2d');

            const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
            const data = imageData.data;
        
            for (let i = 0; i < data.length; i += 4) {
                data[i] = 255 - data[i]; // 红色反转
                data[i + 1] = 255 - data[i + 1]; // 绿色反转
                data[i + 2] = 255 - data[i + 2]; // 蓝色反转
            }
        
            ctx.putImageData(imageData, 0, 0);
        },
        async setImage(url) {
            // 检查图片是否已经在缓存中
            if (!this.imageCache[url]) {
                // 如果没有缓存，则加载图片
                const image = new Image();
                await new Promise((resolve, reject) => {
                    image.onload = resolve;
                    image.onerror = reject;
                    image.src = url;
                });
                // 加载完成后，将图片缓存起来
                this.imageCache[url] = image;
            }
        },
        drawImageOnCanvas(imageSrc) {
            const canvas = this.$refs.canvas;
            const ctx = canvas.getContext('2d');

            const image = new Image();

            // if(image.complete) {
            //     ctx.drawImage(image,0,0);
            //     return;
            // }
            image.onload = () => {
                ctx.drawImage(image, 30, 0, canvas.width-70, canvas.height-100);
            };

            image.src = imageSrc;
        },
        updateWindowDimensions() {
            this.width = window.innerWidth;
            this.height = window.innerHeight * 0.7;
            this.heightA = window.innerHeight - 110;
        },
        async loadImage(url) {
            // 检查图片是否已经在缓存中
            if (!this.imageCache[url]) {
                // 如果没有缓存，则加载图片
                // this.delayedMessage = newValue;
                const image = new Image();
                await new Promise((resolve, reject) => {
                    image.onload = resolve;
                    image.onerror = reject;
                    image.src = url;
                });
                // 加载完成后，将图片缓存起来
                this.imageCache[url] = image;
            }
            const canvas = this.$refs.canvas;
            // 使用缓存中的图片进行绘制
            const ctx = canvas.getContext('2d');
            // ctx.drawImage(this.imageCache[url], 0, 0);
            ctx.drawImage(this.imageCache[url], 35, 0, canvas.width-70, canvas.height-100);
        },
        handleTouchMove(event) {
            event.preventDefault();
            const touch = event.touches[0];
            const currentX = touch.pageX;
            const currentY = touch.pageY;
            if(this.dddindex == 4){
                if(this.startX1 == 0 && this.startY1 == 0){
                }else{
                    const canvas = this.$refs.canvas;
                    const ctx = canvas.getContext('2d');
                    this.startX = currentX - this.startX1 +this.startX ;
                    this.startY = currentY - this.startY1 +this.startY ;
                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                    ctx.drawImage(this.imageCache[this.pictures[this.slidernub]], this.startX+35 , this.startY,
                     (this.sfWidth == 0 ? canvas.width-70: this.sfWidth), (this.sfHeight == 0 ? canvas.height-100: this.sfHeight))
                }
                this.startX1 = currentX;
                this.startY1 = currentY;
            }else if(this.dddindex == 2){
                const canvas = this.$refs.canvas;
                const ctx = canvas.getContext('2d');
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                if(this.sfWidth == 0 && this.sfHeight == 0){
                    this.sfWidth=(canvas.width-70)
                    this.sfHeight=(canvas.height-100)
                }else{
                    if(currentY - this.sfcurrentY > 0){
                        this.sfWidth=(this.sfWidth)+(0.01 * currentX)
                        this.sfHeight=(this.sfHeight)+(0.01 * currentY)
                    }else{
                        this.sfWidth=(this.sfWidth)-(0.01 * currentX)
                        this.sfHeight=(this.sfHeight)-(0.01 * currentY)
                    }
                }
                ctx.drawImage(this.imageCache[this.pictures[this.slidernub]], (this.startX == 0 ? 35: this.startX+35) , (this.startY == 0 ? 0: this.startY), this.sfWidth, this.sfHeight)
                this.sfcurrentY = currentY;
            }
        },
        handleTouchEnd(event) {
            this.startX1 = 0;
            this.startY1 = 0;
        },
        clickdbd(dddi){
            this.dddindex = dddi
            if(dddi!==0){
                this.changeCanvas()
            }
            // if(dddi == 4){
            //     this.changeCanvasFS()

            // }
        },
        spflipCanvas() {
            const canvas = this.$refs.canvas;
            const ctx = canvas.getContext('2d');
            const tempCanvas = document.createElement('canvas');
            const tempCtx = tempCanvas.getContext('2d');
            tempCanvas.width = canvas.width;
            tempCanvas.height = canvas.height;
            tempCtx.drawImage(canvas, 0, 0);
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.save()
            ctx.scale(-1, 1)
            ctx.drawImage(tempCanvas, -canvas.width+0, -0, canvas.width, canvas.height)
            ctx.restore()
        },
        sxflipCanvas() {
            const canvas = this.$refs.canvas;
            const ctx = canvas.getContext('2d');
            const tempCanvas = document.createElement('canvas');
            const tempCtx = tempCanvas.getContext('2d');
            tempCanvas.width = canvas.width;
            tempCanvas.height = canvas.height;
            tempCtx.drawImage(canvas, 0, 0);
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.save()
            ctx.scale(-1, 1)
            ctx.translate(-canvas.width, 0+canvas.height) 
            ctx.rotate(180 * Math.PI / 180)
            ctx.drawImage(tempCanvas, -canvas.width-0, 0, canvas.width, canvas.height)
            ctx.restore()
        },
        czflipCanvas(){
            this.loadImage(this.pictures[this.slidernub])
        }
    },
};
</script>

<style scoped>
.selectcoucss{
    color: #1286ff !important;
}
.el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 100px;
    margin: 0;
  }
  
  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }
  
  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
  body{overflow:hidden;}
  .my-swipe .swipe-image {
  width: 100%;
  height: 200px;
  display: block;
}
.image-container {
  position: relative;
  display: inline-block; /* 或者其他适合的布局方式 */
}
 
.image-container img {
  width: 100%; /* 根据需要调整宽度 */
  height: auto; /* 保持图片的宽高比 */
}
 
.text-overlay {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    padding: 5px;
    background-color: rgba(0, 0, 0, 0.5);
    color: #fff;
    font-size: 11px;
}
</style>